import { Typography } from "antd";
import React from "react";

const { Title, Paragraph } = Typography;

const PortfolioTitle = () => {
  return (
    <div>
      <div
        style={{
          padding: "5rem 0",
          textAlign: "center",
          backgroundColor: "#112240",
        }}
      >
        <Title level={3} style={{ color: "#FFF" }}>
          Portfolio
        </Title>
        <Paragraph level={5} style={{ color: "#FFF" }}>
          "IF YOU WANT, YOU CAN OVERCOME ALL: THE PRESSURE, THE EXPECTATIONS,
          GRAVITY."
        </Paragraph>
      </div>
    </div>
  );
};

export default PortfolioTitle;
